<template>
    <div id="modal_price_rule" class="modal">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p id="rule_name" class="modal-card-title">{{ modalRuleName }}</p>
                <button class="delete" aria-label="close" @click="doClose()"></button>
            </header>
            <section class="modal-card-body">
                <div style="display: flex; flex-direction: column">
                    <div>Description</div>
                    <textarea v-model="ruleDescription" class="textarea" id="rule_description" style="
              height: 10rem;
              overflow-y: auto;
              overflow-x: auto;
              cursor: text;
            " disabled @change="handleStateChange($event)">
          </textarea>
                    <div style="margin-top: 1em">Instructions</div>
                    <textarea class="textarea" v-model="ruleInstruction" id="rule_instructions" style="
              height: 10rem;
              overflow-y: auto;
              overflow-x: auto;
              cursor: text;
            " disabled @change="handleStateChange($event)">
          </textarea>
                </div>
            </section>
            <footer class="modal-card-foot">
                <div class="buttons is-right" style="width: 100%">
                    <span style="margin-right: 3em">
                        Suggested Price:
                        <strong id="rule_suggested_price">{{ suggestedPrice }}</strong>
                    </span>
                    <button class="button" @click="doClose()">Cancel</button>
                    <button class="button is-info" @click="doUse()">Use Price</button>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalPriceRuleDetails",
    props: {
        modalRuleName: {
            type: String,
            required: true,
        },
        modalRuleDescription: {
            type: String,
            required: true,
        },
        modalRuleInstruction: {
            type: String,
            required: true,
        },
        suggestedPrice: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            ruleDescription: '',
            ruleInstruction: ''
        }
    },
    mounted() {
        this.ruleDescription = this.modalRuleDescription
        this.ruleInstruction = this.modalRuleInstruction
    },
    methods: {
        doClose() {
            this.$emit("doClose");
        },
        doUse() {
            this.$emit("doUse");
        },
        handleStateChange($event) {
            this.$emit("handleStateChange", $event.target.value);
        },
    },
};
</script>